export { ColorsService } from './colors.service';